const template = document.createElement('template');

template.innerHTML = `
<style>
.cms-made-with {
  color: hsla(210,9%,9%,1);
  font-family: Helvetica Neue,-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol',sans-serif;
  font-size: 16px;
  line-height: 1.375em;
  padding: 8px 16px;
  font-weight: 500;
  background: hsla(0,0%,100%,1);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  border-radius: 3px;
  z-index: 1;
  text-decoration: none;
}

.cms-made-with__logo {
  margin-left: 8px;
  max-width: 36px;
  max-height: 23.31px;
}
</style>
<a href="#" class="cms-made-with" data-track-event="Modal Signup Invocation" data-track-label="Easy Splash Signup Click">
  <span class="cms-made-with__title"></span>
  <img class="cms-made-with__logo" alt="logo" height="auto" />
</a>
`.trim();

export default template;
